import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService } from '../../shared/services';
import { InspectionPlugin } from '../../shared/models/index';

@Injectable()
export class EffectsPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateEffects(inspectionId: string, pointId: string, pluginId: string, effects: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, effects).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, effects: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, effects, 'Effects').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
